<template>
  <div class="watermark-container" ref="watermarkContainer">
    <div 
      class="watermark-text" 
      v-for="(item, index) in watermarkArray" 
      :key="index"
      :style="getWatermarkItemStyle(index)"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'WatermarkText',
  data() {
    return {
      text: '刘小刘资源站',
      watermarkArray: [],
      containerSize: {
        width: 0,
        height: 0
      },
      config: {
        color: 'rgba(8, 145, 178, 0.04)',
        fontSize: '14px',
        fontWeight: '500',
        rotate: -20,
        horizontalSpace: 180,
        verticalSpace: 120
      }
    };
  },

  mounted() {
    this.initWatermark();
    window.addEventListener('resize', this.initWatermark);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.initWatermark);
  },
  methods: {
    initWatermark() {
      this.getContainerSize();
      this.calculateWatermarkCount();
    },
    
    getContainerSize() {
      const container = this.$refs.watermarkContainer;
      if (container && container.parentElement) {
        this.containerSize = {
          width: container.parentElement.scrollWidth,
          height: container.parentElement.scrollHeight
        };
      }
    },
    
    calculateWatermarkCount() {
      const { width, height } = this.containerSize;
      const rows = Math.ceil(height / this.config.verticalSpace) + 2;
      const cols = Math.ceil(width / this.config.horizontalSpace) + 2;
      
      this.watermarkArray = [];
      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
          this.watermarkArray.push({ row, col });
        }
      }
    },
    
    getWatermarkItemStyle(index) {
      const { row, col } = this.watermarkArray[index];
      
      return {
        color: this.config.color,
        fontSize: this.config.fontSize,
        fontWeight: this.config.fontWeight,
        transform: `rotate(${this.config.rotate}deg)`,
        left: `${col * this.config.horizontalSpace}px`,
        top: `${row * this.config.verticalSpace}px`
      };
    }
  }
};
</script>

<style scoped>
.watermark-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.watermark-text {
  position: absolute;
  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, sans-serif;
  white-space: nowrap;
  transform-origin: left top;
  user-select: none;
  -webkit-user-select: none;
}
</style>